/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RegisterRequestBody,
  RegisterRequestBody$Outbound,
  RegisterRequestBody$outboundSchema,
} from "../components/registerrequestbody.js";

export type RegisterSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RegisterRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  registerRequestBody: RegisterRequestBody;
};

/** @internal */
export type RegisterSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RegisterSecurity$outboundSchema: z.ZodMiniType<
  RegisterSecurity$Outbound,
  RegisterSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function registerSecurityToJSON(
  registerSecurity: RegisterSecurity,
): string {
  return JSON.stringify(
    RegisterSecurity$outboundSchema.parse(registerSecurity),
  );
}

/** @internal */
export type RegisterRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RegisterRequestBody: RegisterRequestBody$Outbound;
};

/** @internal */
export const RegisterRequest$outboundSchema: z.ZodMiniType<
  RegisterRequest$Outbound,
  RegisterRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    registerRequestBody: RegisterRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      registerRequestBody: "RegisterRequestBody",
    });
  }),
);

export function registerRequestToJSON(
  registerRequest: RegisterRequest,
): string {
  return JSON.stringify(RegisterRequest$outboundSchema.parse(registerRequest));
}
